/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/${encodeURIComponent(request.path['deviceId'] as any)}/confirmation`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/{deviceId}/confirmation',
    method: 'PATCH',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Confirms a trusted device registration by verifying the confirmation and saving the device
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    deviceId: string
  }
  body: {
    /**
     * The email address of the user confirming the trusted device.
     */
    email: string
    /**
     * UUID of the confirmation request to verify.
     */
    confirmationId: string
  }
}

export type Response =
  | {
      /**
       * UUID of the confirmed trusted device.
       */
      deviceId: string
      /**
       * ISO 8601 timestamp of when the confirmation was requested
       */
      requestedAt?: string
      /**
       * User-Agent string of the device that requested confirmation
       */
      userAgent?: string
      /**
       * City derived from the request IP address
       */
      city?: string
      /**
       * Country derived from the request IP address
       */
      country?: string
    }
  | {
      /**
       * Error code for why the confirmation failed.
       */
      code: 'TrustedDeviceConfirmationExpired' | 'TrustedDeviceAlreadyRegistered'
    }

